import classNames from 'classnames';

function Heading1({ children, className, ...rest }) {
  const classes = classNames("text-xl sm:text-3xl md:text-4xl text-center font-bold", className);

  return <h1 className={classes} {...rest}>{children}</h1>
}

export default Heading1;
